"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidSelector = void 0;
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
const isValidSelector = selector => {
  if (!selector || typeof selector !== 'string') return false;
  try {
    document.createDocumentFragment().querySelector(selector);
  } catch {
    return false;
  }
  return true;
};
exports.isValidSelector = isValidSelector;